/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Go_To_First_PageInputs */

const en_table_go_to_first_page = /** @type {(inputs: Table_Go_To_First_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to first page`)
};

const pt_br2_table_go_to_first_page = /** @type {(inputs: Table_Go_To_First_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para a primeira página`)
};

/**
* | output |
* | --- |
* | "Go to first page" |
*
* @param {Table_Go_To_First_PageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_go_to_first_page = /** @type {((inputs?: Table_Go_To_First_PageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Go_To_First_PageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_go_to_first_page(inputs)
	return pt_br2_table_go_to_first_page(inputs)
});